import { createContext, EActiveView, EEventType } from '@cian/authentication-widget';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const useAuthContext = () => {
  const { custom, config, httpApi, logger } = useApplicationContext();

  const authContext = createContext(
    {
      httpApi,
      logger,
      config,
      subdomain: custom.subdomain,
    },
    {
      view: {
        active: EActiveView.RememberedAccountsSelect,
      },
    },
  );

  authContext.on(EEventType.AuthenticateSucceed, async () => {
    window.location.reload();
  });

  return { authContext };
};
